import { joinCommandBarButtonText } from './getJoinCommandBarButton.locstring.json';
import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import type { CalendarEvent } from 'owa-calendar-types';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import {
    OnlineMeetingProviderType,
    getIconFromProviderName,
    isValidOnlineMeeting,
    getJoinMeetingLabelFromProviderName,
} from 'owa-online-meeting';

/**
 * Returns the button for Join meeting
 * @param event Calendar event
 * @param actionSource Calendar view
 */
export const getJoinCommandBarButton = (
    event: CalendarEvent,
    actionSource: ViewType
): FilterableMenuItem => {
    const iconName = getIconFromProviderName(
        event.OnlineMeetingProvider as OnlineMeetingProviderType
    );
    const joinMeetingLabel = getJoinMeetingLabelFromProviderName(
        event.OnlineMeetingProvider as OnlineMeetingProviderType
    );

    const onClick = () => {
        userInteractionAction(
            'JoinOnlineMeeting',
            actionSource,
            event.IsOrganizer,
            event.IsMeeting,
            [event.OnlineMeetingProvider]
        );
    };

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(joinCommandBarButtonText),
        [FilterableMenuItemArgs.icon]: iconName,
        [FilterableMenuItemArgs.onClick]: onClick,
        [FilterableMenuItemArgs.shouldShow]: () => isValidOnlineMeeting(event),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.key]: 'Join',
        [FilterableMenuItemArgs.href]: event.OnlineMeetingJoinUrl,
        [FilterableMenuItemArgs.ariaLabel]: joinMeetingLabel,
    });
};
